import { render, staticRenderFns } from "./riskDateField.vue?vue&type=template&id=3396d666"
import script from "./riskDateField.vue?vue&type=script&lang=js"
export * from "./riskDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports